export default __webpack_public_path__ + "static/media/transforma-tu-comunidad.68a1c341.png";